import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { RateManagerService,RateManager} from '@app/_components/rate/rate-manager';
import { AuthenticationService, AlertService } from '../../../../_services';
import { Router } from '@angular/router';
import { SelectItem, LazyLoadEvent } from 'primeng/api';

@Component({
    selector: 'app-rate-manager-list',
    templateUrl: './rate-manager-list.component.html',
    styleUrls: ['./rate-manager-list.component.css'],
    standalone: false
})
export class RateManagerListComponent implements OnInit
{
    datasource: RateManager[];
    rateManager: RateManager;
    rateManagers: RateManager[] = [];
    columns: any[];
    recordTotal: number;
    lazyLoadEvent: LazyLoadEvent;
    loading = true;
    userStatusOptions: SelectItem[];


    constructor(
        private authenticationService: AuthenticationService,
        private rateManagerService: RateManagerService,
        private alertService: AlertService,
        private router: Router
    ) { }


    ngOnInit()
    {
        try
        {
            this.columns = [
                { field: 'rateManagerId', header: 'Id' },
                { field: 'description', header: 'Description' },
                { field: 'name', header: 'Name' }
            ];

        } catch (error)
        {
            console.log('ngOnInit() ' + error);
        }
    }

    loadLazy(event: LazyLoadEvent)
    {
        try
        {
            this.loading = true;
            this.lazyLoadEvent = event;

            console.log(
                ' event.first:' + event.first
                + '  |  event.rows:' + event.rows
                + '  |  event.sortField:' + event.sortField
                + '  |  event.sortOrder:' + event.sortOrder
                + '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
                + '  |  event.globalFilter:' + event.globalFilter
                + '  |  event.filters:' + JSON.stringify(event.filters)
            );

            const pageNumber = Math.round(event.first / event.rows);
            this.rateManagerService.findByFilter(
                pageNumber, event.rows,
                event.sortField,
                event.sortOrder,
                event.multiSortMeta,
                event.globalFilter,
                event.filters).pipe(first()).subscribe(

                    data =>
                    {
                        console.log('users are: ' + JSON.stringify(data));
                        this.datasource = data.data.rateManagers;
                        this.recordTotal = data.page.recordTotal;
                        this.rateManagers = data.data.rateManagers;
                    },
                    error =>
                    {
                        console.log('USER LIST!: ' + JSON.stringify(error));
                        this.alertService.error(error);
                    },
                    () =>
                    { this.loading = false; }
                );

            if (this.datasource)
            {
                this.rateManagers = this.datasource.slice(event.first, (event.first + event.rows));
            }
        } catch (error)
        {
            console.log('loadLazy(' + event + ')' + error);
        }
    }
    onRowSelect(event)
    {
        try
        {
            // use this for adding query params
            // this.router.navigate(['user-edit'], { queryParams: { userId: event.data.userId } });
            this.router.navigate(['rate-manager-view', event.data.rateManagerId]);
        } catch (error)
        {
            console.log('onRowSelect(' + event + ')' + error);
        }
    }

reloadPage() {
		window.location.reload();
	}
}
